<template>
  <div class="px-4 pt-4 flex justify-between items-center relative" :data-testid="dataTestId">
    <div class="md:flex justify-center items-center space-x-2" tabindex="1">
      <label class="font-[Montserrat] font-semibold text-[24px] leading-[30px]">{{ title }}</label>
      <span
        v-if="toastMenu?.show ?? false"
        v-tooltip.focus.right="{
          value: toastMenu?.description,
          id: 'top-menu-col-header-tooltip',
          ...tooltipSetup,
        }"
        tabindex="1"
        @click="(e) => e.target.focus()"
        @mouseenter="(e) => e.target.focus()"
        @mouseleave="(e) => e.target.blur()"
      >
        <HelpIcon class="cursor-pointer" />
      </span>
    </div>
    <div v-if="showPopupMenu" class="flex justify-end items-center">
      <span class="font-[Montserrat] font-semibold text-[15px] leading-[30px]">MENU</span>
      <button
        class="p-2 relative"
        :data-testid="`${dataTestId}-button`"
        @mouseover="isMenuOpen = true"
        @mouseleave="isMenuOpen = false"
      >
        <AppsIcon class="w-10 h-10" />
      </button>
    </div>
    <transition name="fade">
      <div
        v-if="isMenuOpen"
        class="absolute top-16 right-5 bg-white shadow-lg rounded-lg p-3 border border-gray-200 z-[100] w-[320px]"
        :data-testid="`${dataTestId}-dropdown`"
        @mouseover="isMenuOpen = true"
        @mouseleave="isMenuOpen = false"
      >
        <slot name="sections">
          <div v-for="(section, index) in sections" :key="index" :data-testid="`${dataTestId}-section-${index}`">
            <SidebarSection
              :title="section.title"
              :items="section.items"
              :data-test-id="`${dataTestId}-section-${index}`"
              @menu-item-clicked="toggleMenu"
            />
          </div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script setup>
import Tooltip from "primevue/tooltip";
import { defineProps, ref } from "vue";
import { AppsIcon } from "@/components/svg-icons";
import { HelpIcon } from "../../shared/icons";
import SidebarSection from "./SidebarSection.vue";

const vTooltip = Tooltip;
const tooltipSetup = {
  fitContent: true,
  class: "bg-white shadow rounded white",
  hideDelay: "0.3",
  pt: {
    text: "text-indigo-base p-3 leading-none",
  },
};

defineProps({
  title: {
    type: String,
    required: true,
  },
  sections: {
    type: Array,
    required: false,
    default: [],
  },
  showPopupMenu: {
    type: Boolean,
    default: true,
  },
  toastMenu: {
    type: Object,
    default: () => ({ show: false, description: "" }),
  },
  dataTestId: {
    type: String,
    required: true,
  },
});

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>
